export const VIDEOS_QUERY_PARAM = 'topics'

export const VIDEOS_TEST_IDS = {
  page: 'videos-page',
  header: 'videos-header',
  grid: 'videos-grid',
  topicsFilter: 'videos-topics-filter',
  topicsReset: 'videos-topics-reset',
  videoCard: 'videos-card',
  detailPage: 'video-detail-page',
  youtubeEmbed: 'video-youtube-embed',
} as const
